import { IState } from './types'
import config from '../../../../public/config.json'
import { mapActions } from 'vuex'

const allMarkets = (state: IState) => {
  return state.markets
}
const allNomenclatures = (state: IState) => {
  return state.nomenclatures
}
const allCategories = (state: IState) => {
  return state.categories
}
const allRoots = (state: IState) => {
  return state.roots
}
const allSectors = (state: IState) => {
  return state.sectors
}
const allSubMarkets = (state: IState) => {
  return state.subMarkets
}
const allSegments = (state: IState) => {
  return state.segments
}

const allFamilies = (state: IState) => {
  return state.families
}

export default {
  allMarkets,
  allNomenclatures,
  allCategories,
  allRoots,
  allSectors,
  allSegments,
  allSubMarkets,
  allFamilies,
}
